import NotificationsBar from './styled';

export default NotificationsBar;
